import React, { FC, Fragment } from 'react'

import UnitPrice from './UnitPrice'
import BoldPrice from './BoldPrice'

type Props = {
  quantity: number
  pricePerUnit: number
  intl: any
  index: number
}

const RegularPrice: FC<Props> = ({ quantity, pricePerUnit, intl, index }) => {
  const totalPrice = quantity * pricePerUnit

  return (
    <Fragment>
      <span
        style={{ fontWeight: 'inherit' }}
        id={`productlistitem-${index}-price`}
      >
        <BoldPrice value={totalPrice} />
      </span>
      {quantity > 1 && <UnitPrice pricePerUnit={pricePerUnit} intl={intl} />}
    </Fragment>
  )
}

export default RegularPrice
